import {
  countExpectedGapInsertions,
  detectHrDataIssues,
  hasRepairableIssues,
} from '../../../ai-repair';
import type { HeartRateEvent } from '@model/DeviceConfiguration';
import type { DeterministicAnalysisResult } from '../types';

export const runDeterministicAnalysis = (
  events: HeartRateEvent[]
): DeterministicAnalysisResult => {
  const issues = detectHrDataIssues(events);

  if (!hasRepairableIssues(issues)) {
    return {
      status: 'clean',
      duplicateCount: 0,
      gapCount: 0,
      gapInsertionCount: 0,
      findings: ['Nessun duplicato nello stesso secondo né gap rilevati.'],
    };
  }

  const duplicateCount = issues.duplicates.length;
  const gapCount = issues.gaps.length;
  const gapInsertionCount = countExpectedGapInsertions(issues);

  const findings = [
    duplicateCount > 0
      ? `${duplicateCount} secondi con eventi duplicati.`
      : null,
    gapCount > 0
      ? `${gapCount} gap con ${gapInsertionCount} secondi mancanti.`
      : null,
  ].filter((item): item is string => Boolean(item));

  return {
    status: 'needs_repair',
    duplicateCount,
    gapCount,
    gapInsertionCount,
    findings,
  };
};
